import { HomeContainer } from "@/containers/HomeContainer";
import { getCdnImageSrc } from "goi_common";

export const getStaticProps = async () => {
  const title = "모바일 부고장 | 모바일 부고장 만들기, 고이부고";
  const description =
    "모바일 부고장 만들기부터 카카오톡 발송까지 한번에. 모바일 부고장 양식 무료 제공, 부고 알림을 가족·지인에게 간편하게 전달하세요. 온라인 부고 서비스 고이부고.";
  const keywords =
    "부고, 부고장, 모바일부고, 모바일부고장, 부고장만들기, 부고알림, 카카오부고, 부고문자, 온라인부고, 고이부고, 장례, 장례식장, 부고장양식";
  return {
    props: {
      pageOgTitle: title,
      pageDescription: description,
      pageKeywords: keywords,
      pageOgImage: `${getCdnImageSrc("bugo/bugo_kakao_share.png")}`,
    },
  };
};

/** TODO: og:image, og:description, og:title 해줘야함 */
const Home = () => {
  return <HomeContainer />;
};

export default Home;
